import { createSelector } from 'reselect';

import { selectPermissions } from '../user/selectors';

import { headerSelector } from './header-selector';
import { sidenavSelector } from './sidenav-selector';

export const viewContextSelector = createSelector(
  [sidenavSelector, headerSelector, selectPermissions],
  (sidenav, header, permissions) => {
    return {
      // Nav: External
      ...sidenav,
      // Header
      ...header,
      // Other
      ...permissions,
    };
  }
);
